import * as React from "react";
import PropTypes from "prop-types";
import GBStdTable from "../../../Library/Tables/GBStdTable";

/* Everything should be declared in one placed. Change later. Copied these names from SCDataEntryDrawer. */
const VMMCsPerformedStartRow = 1;
const VMMCsPerformedTotalRow = 13;
const dataCol = 2;
const numVMMC_AgeGroups = 12;
const numFollowUpRates = 3;
const numAdversEventTypes = 3;

/* Not from SCDataEntryDrawer ... yet. */
const numSTIPosRows = 2;
const numHIVPosRows = 3;
const lastRow = 25;

class SCProductivityTable extends React.Component {
    //==================================================================================================================
    //
    //                                             Props and State
    //
    //==================================================================================================================

    static propTypes = {
        indInfo: PropTypes.object,
        catInfo: PropTypes.object,
        mstIDsObj: PropTypes.object,
        value: PropTypes.arrayOf(PropTypes.array),
        onChange: PropTypes.func,
    };

    static defaultProps = {
        indInfo: null,
        catInfo: null,
        mstIDsObj: PropTypes.object,
        value: [
            ["", "", "Month"],
            ["VMMCs performed", "<1", VMMCsPerformedStartRow],
            ["", "1-4", 2],
            ["", "5-9", 3],
            ["", "10-14", 4],
            ["", "15-19", 5],
            ["", "20-24", 6],
            ["", "25-29", 7],
            ["", "30-34", 8],
            ["", "35-39", 9],
            ["", "40-44", 10],
            ["", "45-49", 11],
            ["", "50+", 12],
            ["", "Total", VMMCsPerformedTotalRow],
            ["Day of Operation", "", 14],
            ["Follow Up", "48H", 15],
            ["", "7 days", 16],
            ["", "6 weeks", 17],
            ["Adverse Events", "Mild", 18],
            ["", "Moderate", 19],
            ["", "Severe", 20],
            ["STI (VMMC clients only)", "STI+", 21],
            ["", "STI treated & Circumcised", 22],
            ["HIV Testing (VMMC clients only)", "HIV tests performed", 23],
            ["", "HIV+", 24],
            ["", "Enrolled C&T", lastRow],
        ],
        onChange: () => console.log("onChange"),
    };

    //==================================================================================================================
    //
    //                                                 Events
    //
    //==================================================================================================================

    onSheetCellsChanged = (hot, packTable) => {
        try {
            let newPackTable = JSON.parse(JSON.stringify(packTable));
            newPackTable.tableData.value[VMMCsPerformedTotalRow][dataCol] = 0;

            for (let i = VMMCsPerformedStartRow; i <= VMMCsPerformedTotalRow - 1; i++) {
                if (newPackTable.tableData.value[i][dataCol] !== "") {
                    newPackTable.tableData.value[VMMCsPerformedTotalRow][dataCol] =
                        newPackTable.tableData.value[VMMCsPerformedTotalRow][dataCol] +
                        newPackTable.tableData.value[i][dataCol];
                }
            }

            this.props.onChange(hot, newPackTable);
        } catch (exception) {
            alert(exception.name + ": " + exception.message);
        }
    };

    //==================================================================================================================
    //
    //                                                Render
    //
    //==================================================================================================================

    render() {
        try {
            let MAX_VALUE = 999999999;
            let styles = {
                innerPage: {
                    margin: 20,
                },
            };

            const catName = "Performance"; //getCategoryName(SCConst.cat_SiteProdMstID, this.props.catInfo, this.props.mstIDsObj);

            let values = JSON.parse(JSON.stringify(this.props.value));

            let GBRowHeights = [];
            GBRowHeights.length = lastRow + 1;
            GBRowHeights.fill(-1);

            let minAllowedVal = [];
            minAllowedVal.length = lastRow + 1;
            minAllowedVal.fill([0, 0, 0]);

            let maxAllowedVal = [];
            maxAllowedVal.length = lastRow + 1;
            maxAllowedVal.fill([0, 0, MAX_VALUE]);
            maxAllowedVal[0] = [0, 0, 0];

            let lockedCells = [];
            lockedCells.length = lastRow + 1;
            lockedCells.fill([false, true, false]);
            lockedCells[0] = [false, false, false];
            lockedCells[VMMCsPerformedTotalRow] = [false, true, true];

            return (
                <div style={styles.innerPage}>
                    <h5>{catName}</h5>

                    <GBStdTable
                        id="VMMCDoneTable"
                        minHeight={580}
                        maxHeight={580}
                        packTable={{
                            GBFixedRows: 1,
                            GBFixedCols: dataCol,
                            GBRowCount: lastRow,
                            GBColCount: dataCol + 1,
                            GBColWidths: [300, 325, 100],
                            GBRowHeights: GBRowHeights,
                            MinAllowedVal: minAllowedVal,
                            MaxAllowedVal: maxAllowedVal,
                            LockedCells: lockedCells,
                            MergedCells: [
                                {
                                    startRow: VMMCsPerformedStartRow,
                                    startCol: 0,
                                    numRows: numVMMC_AgeGroups + 1, // includes Total
                                    numCols: 1,
                                },
                                {
                                    startRow: VMMCsPerformedTotalRow + 2, // +1 to get to next row, + 1 to skips Days of operation row
                                    startCol: 0,
                                    numRows: numFollowUpRates,
                                    numCols: 1,
                                },
                                {
                                    startRow: VMMCsPerformedTotalRow + numFollowUpRates + 2, // +1 to get to next row, + 1 to skips Days of operation row
                                    startCol: 0,
                                    numRows: numAdversEventTypes,
                                    numCols: 1,
                                },
                                {
                                    startRow: VMMCsPerformedTotalRow + numFollowUpRates + numAdversEventTypes + 2, // +1 to get to next row, + 1 to skips Days of operation row
                                    startCol: 0,
                                    numRows: numSTIPosRows,
                                    numCols: 1,
                                },
                                {
                                    startRow:
                                        VMMCsPerformedTotalRow +
                                        numFollowUpRates +
                                        numAdversEventTypes +
                                        numSTIPosRows +
                                        2, // +1 to get to next row, + 1 to skips Days of operation row
                                    startCol: 0,
                                    numRows: numHIVPosRows,
                                    numCols: 1,
                                },
                            ],
                            tableData: {
                                value: values,
                            },
                            AllowBlanks: true, // mark
                        }}
                        onSheetCellsChanged={this.onSheetCellsChanged}
                    />
                </div>
            );
        } catch (exception) {
            return (
                <div
                    className={"SCProductivityTableDiv"}
                    key={"SCProductivityTableDiv"}
                >
                    <h3 key={"SCProductivityTableDivH3"}>{exception.name + ": " + exception.message}</h3>
                </div>
            );
        }
    }
}

export default SCProductivityTable;
